module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-5-svgrepo-com.6fc10c35.svg";